import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';
import ReactMarkdown from 'react-markdown';

export function Terms() {
  const [terms, setTerms] = useState(`# Terms of Service

Last Updated: ${new Date().toLocaleDateString()}

## 1. Subscription Terms

### 1.1 Billing Cycle
- Subscriptions are billed in advance on a monthly or annual basis
- Annual subscriptions receive a 20% discount
- The billing cycle starts on the date of subscription

### 1.2 Usage Limits
- Each plan has specific monthly limits for video processing
- Usage limits reset at the start of each billing cycle
- Unused minutes or videos do not roll over to the next billing cycle

### 1.3 Payment Processing
- All payments are processed securely through Stripe
- Prices are in USD and include applicable taxes
- Failed payments may result in service interruption

### 1.4 Plan Changes

#### Upgrades
- Plan upgrades take effect immediately
- You will be charged a prorated amount for the remainder of the current billing cycle
- The new plan's limits become available immediately

#### Downgrades
- Plan downgrades take effect at the end of the current billing cycle
- You will continue to have access to your current plan's features until the end of the billing period
- No refunds are provided for unused time

### 1.5 Cancellation Policy
- You may cancel your subscription at any time
- No refunds are provided for partial months or unused time
- Service continues until the end of the current billing period
- After cancellation, your account will revert to the free plan

### 1.6 Refund Policy
- All purchases are final and non-refundable
- In cases of technical issues preventing service delivery, contact support for resolution

## 2. Service Terms

### 2.1 Fair Usage
- The service is provided for normal business use
- We reserve the right to limit excessive usage that impacts other users

### 2.2 Account Security
- You are responsible for maintaining the security of your account
- Notify us immediately of any unauthorized use

### 2.3 Service Availability
- We strive for 99.9% uptime but do not guarantee uninterrupted service
- Scheduled maintenance will be announced in advance

## 3. Content & Data

### 3.1 Your Content
- You retain all rights to your uploaded content
- You grant us license to process your content for service delivery

### 3.2 Data Processing
- Content is processed using AI services
- We implement industry-standard security measures

## 4. Changes to Terms

We may update these terms from time to time. We will notify you of any material changes via email or through the service.

## 5. Contact Information

For questions about these terms or our service:
- Email: support@postcaptionslab.com
- Website: https://postcaptionslab.com`);

  useEffect(() => {
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('terms_of_service')
        .eq('id', 1)
        .single();

      if (error) throw error;
      setTerms(data.terms_of_service);
    } catch (error) {
      console.error('Error fetching terms:', error);
      // Keep default terms if there's an error
    }
  };

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-card rounded-lg shadow-sm p-8 border">
          <article className="prose dark:prose-invert prose-blue max-w-none">
            <ReactMarkdown>{terms}</ReactMarkdown>
          </article>
        </div>
      </div>
    </div>
  );
}